<template>

  <div>
    <link href="https://fonts.googleapis.com/css2?family=Work+Sans:wght@400;600;700&display=swap" rel="stylesheet">
    <!--  css -->
    <!-- <link rel="stylesheet" href="http://ux.gluo.mx/ux/projects/unitec/prospeccion/clientlib-site/site.css"
    type="text/css">-->
    <!--<link rel="stylesheet" href="https://dev-unitec.gluo.mx/etc.clientlibs/unitec/clientlibs/clientlib-site.css"
    type="text/css">-->
    <!--<link href="http://ux.gluo.mx/ux/projects/unitec/prospeccion/clientlib-site/site.css" rel="stylesheet">-->
    <!--  css -->
             
    
    <!--Comienzo del componente web contenedor de los componentes para alumno,padre, docente-->
    <div>
    <!--<button @click="abrirForm(tipo)">test</button>-->
    <input type="text"  :value="idsch" hidden="true">
    <component :is="seleccionado" :idsch="idsch" :tpsch="tpsch" :cicloi="ciclo" :tipousuario="tipo"></component> 
    <!--Componenten del alumno -->
    <!--<alumno-component v-model="newvalue"></alumno-component>-->

    <!--Componenten del docente -->
    <!--<docente-component></docente-component>-->

     <!--Componenten del tutor-->
    <!--<tutor-component></tutor-component>-->

  </div>
  </div>
  <!--fin del componente web contenedor de los componentes para alumno,padre, docente-->
</template>

<!--  js -->
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>
<script src="https://cdn.jsdelivr.net/npm/vue@2.5.16/dist/vue.js"></script>
<!--  js -->

<style>
@import url('https://fonts.googleapis.com/css2?family=Work+Sans:wght@400;600;700&display=swap');

body {
  font-family: 'Work Sans', sans-serif;
}
</style>
<script>
//Componentes del alumno
import AlumnoComponent from './components/alumno/AlumnoformComponent'
import DocenteComponent from './components/docente/DocenteformComponent.vue'
import TutorComponent from './components/tutor/TutorformGeneral.vue'
import axios from "axios";
export default {
  name: 'App',
  props:['typeusuario','typeschool','idschool'],
  components: {
     AlumnoComponent,
     DocenteComponent,
     TutorComponent
  },
  data(){
        return {
            seleccionado: this.getTpuser(),
            idsch: this.getIdschool(),
            tpsch: this.getTpchool(),
            ciclo: this.getCiclo(),
            tipo:''
        };
    },

    methods:{
    getTypeuser() {
      axios.get("https://qa.atencionunitec.mx/api/catalogos").then((result) => {
      //console.log(result.data);
      this.tipo = result.data;
     })
     },
    abrirForm(){
            this.seleccionado;
            //alert(val);
    },
    getIdschool(){
      var url_string = window.location.href; 
      var url = new URL(url_string);
      var idEscuela = url.searchParams.get("idSchool");
      return idEscuela;
      //console.log("idEscuela "+idEscuela);  
    },
  getTpchool(){
        var url_string = window.location.href; 
        var url = new URL(url_string);
        var typeSchool = url.searchParams.get("typeSchool");
        var niveleducativo = "";
       // console.log("Tipo de escuela "+typeSchool);
        if(typeSchool == "1"){
          niveleducativo = "PREPARATORIA";
        }
        if(typeSchool == "2"){
          niveleducativo = "LICENCIATURA";
        }
        return niveleducativo;
    },

    getTpuser(){
        var url_string = window.location.href; 
        var url = new URL(url_string);
        var typeUser = url.searchParams.get("typeUser");
        var nameComponent = "AlumnoComponent";
       // console.log("Tipo de usuario "+typeUser);
        if(typeUser == "2"){
          var nameComponent = "AlumnoComponent";
        }
        if(typeUser == "3"){
          var nameComponent = "TutorComponent";
        }
        if(typeUser == "4"){
          var nameComponent = "DocenteComponent";
        }
      return nameComponent;
    },
    getCiclo(){
    var fecha = new Date();
    var añoCiclo = fecha.getFullYear()+1;
    var ciclo = "Septiembre "+añoCiclo;
    //console.log(ciclo);
    return ciclo;
    },
    forceUppercase(e, o, prop) {
      const start = e.target.selectionStart;
      e.target.value = e.target.value.toUpperCase();
      this.$set(o, prop, e.target.value);
      e.target.setSelectionRange(start, start);
    },

     isLetter(e) {
     let char = String.fromCharCode(e.keyCode); // Get the character
     if(/^[A-Za-z\s]+$/.test(char)) return true; // Match with regex 
     else e.preventDefault(); // If not match, don't add to input text
     },
    },
    mounted() {
      this.typeusuario;
      //console.log(this.typeusuario);
      this.abrirForm();
      this.getIdschool();
      this.getTpuser();
      this.getTpchool();
      this.getCiclo();
    }
}
</script>